import { EFileExtension } from 'src/app/project/shared/enums/file-extension.enum';
import { EFileType } from 'src/app/project/shared/enums/file-type.enum';

export const createMediaFileName = (id: string, fileName: string, mimeType: string): string => {
  const baseFileName = id ? `${id}-${fileName}` : fileName;

  switch (mimeType) {
    case EFileType.JPEG:
    case EFileType.JPG:
      return baseFileName + EFileExtension.JPG;
    case EFileType.PNG:
      return baseFileName + EFileExtension.PNG;
    case EFileType.GIF:
      return baseFileName + EFileExtension.GIF;
    case EFileType.BMP:
      return baseFileName + EFileExtension.BMP;
    case EFileType.WEBP:
      return baseFileName + EFileExtension.WEBP;
    case EFileType.MP4:
      return baseFileName + EFileExtension.MP4;
    case EFileType.MPEG:
      return baseFileName + EFileExtension.MPEG;
    case EFileType.OGG:
      return baseFileName + EFileExtension.OGG;
    case EFileType.WEBM:
      return baseFileName + EFileExtension.WEBM;
    case EFileType.GP3:
      return baseFileName + EFileExtension.GP3;
    case EFileType.GP32:
      return baseFileName + EFileExtension.GP32;
    case EFileType.WAVE:
      return baseFileName + EFileExtension.WAVE;
    case EFileType.WAV:
      return baseFileName + EFileExtension.WAV;
    default:
      return baseFileName;
  }
};
